document.addEventListener('DOMContentLoaded', () => {
  const ROOT_SELECTOR = '.wysiwyg__inner';
  const OPEN_CLASS = 'is-open';
  const BLOCK_CLASS = 'readmore';
  const CONTENT_CLASS = 'readmore__content';
  const BTN_CLASS = 'readmore__btn';

  document.querySelectorAll(ROOT_SELECTOR).forEach((root, rootIndex) => {
    // Parse existing HTML into DOM so we can manipulate it safely
    const tpl = document.createElement('template');
    tpl.innerHTML = root.innerHTML;

    // Walk through nodes and build readmore blocks
    const outFrag = document.createDocumentFragment();

    let inReadMore = false;
    let currentBlock = null;
    let currentContent = null;
    let blockCount = 0;

    const flushTextWithMarkers = (text, nodeHandler) => {
      // Splits text nodes around [readmore] and [/readmore]
      const parts = text.split(/(\[readmore\]|\[\/readmore\])/g);

      parts.forEach((part) => {
        if (!part) return;

        if (part === '[readmore]') {
          nodeHandler({ type: 'OPEN' });
          return;
        }
        if (part === '[/readmore]') {
          nodeHandler({ type: 'CLOSE' });
          return;
        }

        nodeHandler({ type: 'TEXT', value: part });
      });
    };

    const startBlock = () => {
  inReadMore = true;
  blockCount += 1;

  const blockEl = document.createElement('div');
  blockEl.className = BLOCK_CLASS;

  const btnEl = document.createElement('button');
  btnEl.type = 'button';
  btnEl.className = BTN_CLASS;
  btnEl.textContent = 'Read more';

  const contentId = `readmore-${rootIndex}-${blockCount}`;
  btnEl.setAttribute('aria-expanded', 'false');
  btnEl.setAttribute('aria-controls', contentId);

  const contentEl = document.createElement('div');
  contentEl.className = CONTENT_CLASS;
  contentEl.id = contentId;

  // Start closed
  contentEl.hidden = true;
  contentEl.style.height = '0px';
  contentEl.style.overflow = 'hidden';

  blockEl.appendChild(btnEl);
  blockEl.appendChild(contentEl);
  outFrag.appendChild(blockEl);

  // Update the “current” pointers used while building content
  currentBlock = blockEl;
  currentContent = contentEl;

  btnEl.addEventListener('click', () => {
    const isOpen = blockEl.classList.contains(OPEN_CLASS);

    if (isOpen) {
      // CLOSE
      btnEl.setAttribute('aria-expanded', 'false');
      btnEl.textContent = 'Read more';

      const h = contentEl.scrollHeight;
      contentEl.style.height = `${h}px`;
      contentEl.hidden = false;

      requestAnimationFrame(() => {
        contentEl.style.height = '0px';
      });

      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        contentEl.hidden = true;
        blockEl.classList.remove(OPEN_CLASS);
        contentEl.removeEventListener('transitionend', onEnd);
      };
      contentEl.addEventListener('transitionend', onEnd);
    } else {
      // OPEN
      btnEl.setAttribute('aria-expanded', 'true');
      btnEl.textContent = 'Read less';

      contentEl.hidden = false;
      contentEl.style.height = '0px';

      requestAnimationFrame(() => {
        contentEl.style.height = `${contentEl.scrollHeight}px`;
      });

      const onEnd = (e) => {
        if (e.propertyName !== 'height') return;
        contentEl.style.height = 'auto';
        blockEl.classList.add(OPEN_CLASS);
        contentEl.removeEventListener('transitionend', onEnd);
      };
      contentEl.addEventListener('transitionend', onEnd);
    }
  });
};


    const endBlock = () => {
      inReadMore = false;
      currentBlock = null;
      currentContent = null;
    };

    // Iterate through the template’s top-level nodes
    Array.from(tpl.content.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        flushTextWithMarkers(node.textContent, (part) => {
          if (part.type === 'OPEN') return startBlock();
          if (part.type === 'CLOSE') return endBlock();

          const textNode = document.createTextNode(part.value);
          if (inReadMore && currentContent) currentContent.appendChild(textNode);
          else outFrag.appendChild(textNode);
        });
        return;
      }

      // For element nodes, we still need to catch markers that might be inside their text
      // BUT: your markers appear as standalone text nodes between tags in most WYSIWYGs.
      // If markers *do* appear inside an element, this keeps it simple: treat the whole element as content.
      if (inReadMore && currentContent) currentContent.appendChild(node);
      else outFrag.appendChild(node);
    });

    // Replace original content
    root.innerHTML = '';
    root.appendChild(outFrag);
  });
});
